import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform);
const mod = isMac ? '⌘' : 'Ctrl';

interface KeyboardShortcutsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function KeyboardShortcutsDialog({ open, onOpenChange }: KeyboardShortcutsDialogProps) {
  const { t } = useTranslation('common');

  // Die Aktions-Gruppe ist mit ihren drei Kuerzeln weg (Task 13). Eine
  // Uebersicht, die Kuerzel auflistet, die nichts tun, ist schlimmer als keine.
  const shortcuts = [
    { group: t('shortcuts.general'), items: [
      { keys: [mod, 'K'], description: t('shortcuts.openCommandPalette') },
      { keys: [mod, 'B'], description: t('shortcuts.toggleSidebar') },
      { keys: [mod, ','], description: t('shortcuts.openSettings') },
      { keys: ['?'], description: t('shortcuts.showShortcuts') },
    ]},
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t('shortcuts.title')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          {shortcuts.map((group) => (
            <div key={group.group}>
              <h4 className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-3">
                {group.group}
              </h4>
              <div className="space-y-2">
                {group.items.map((shortcut) => (
                  <div key={shortcut.description} className="flex items-center justify-between">
                    <span className="text-sm">{shortcut.description}</span>
                    <div className="flex items-center gap-1">
                      {shortcut.keys.map((key, i) => (
                        <kbd key={i} className="inline-flex items-center justify-center rounded border border-border bg-muted px-1.5 py-0.5 text-[11px] font-mono text-muted-foreground min-w-[24px]">
                          {key}
                        </kbd>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
